<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import SupportsDarkMode from "~/mixins/platform/SupportsDarkMode.js";

export default defineNuxtComponent({
	name: "ListBullets",
	mixins: [GizmoComponentMixin, SupportsDarkMode],

	computed: {
		icon() {
			if (this.content.bulletIcon) return this.content.bulletIcon; // Preferred

			// Legacy mapping
			return {
				"Round bullets": "bullet",
				"Checkmark bullets": "success",
			}[this.content.bulletType || -1]; // Will fall back to default defined in ListBulletsBullet
		},
		bullets() {
			// Normalize "normal" and "rich" bullets into a single array

			const itemsBullets = this.content.itemsBullets || [];
			const items = this.content.items || [];

			return [...items, ...itemsBullets]
				.filter((x) => x)
				.map((item) => {
					if (typeof item === "object") {
						// rich
						return {
							heading: item.heading,
							content: item.richtext,
						};
					} else {
						// normal
						return {
							content: item,
						};
					}
				});
		},
		columns() {
			return this.content.maxColumns || 1;
		},
	},
});
</script>

<template>
	<div :class="{ dark }">
		<TnHeading
			v-if="content.heading"
			type="h2"
			class="margin-bottom-m heading"
			>{{ content.heading }}
		</TnHeading>
		<TnHeading
			v-if="content.ingress"
			type="h3"
			class="margin-bottom-xl ingress"
			>{{ content.ingress }}
		</TnHeading>

		<TnBadge
			v-if="content.badgeText"
			class="badge"
			color="blue"
			responsive
			>{{ content.badgeText }}
		</TnBadge>

		<div :class="`grid-columns-${columns} grid-row-gap-l margin-top-2xl`">
			<ListBulletsBullet
				:icon="icon"
				:dark="dark"
				v-for="(bullet, idx) in bullets"
				:key="idx"
			>
				<template #heading>{{ bullet.heading }}</template>
				<div v-html="bullet.content" />
			</ListBulletsBullet>
		</div>
	</div>
</template>

<style scoped lang="scss">
.ingress {
	color: $color-neutrals-600-shade;
}

.dark {
	.heading {
		color: $color-neutrals-white;
	}

	.ingress {
		color: $color-neutrals-200-tint;
	}
}
</style>
